import { useLogOut } from "@/common/api/mutation";
import { useNavigate } from "react-router";
import Typography from "../Typography/Typography";
import { queryClient } from "@/common/utils";

export default function LogOutComponent() {
  const { mutate } = useLogOut();
  const navigate = useNavigate();

  const onLogOutClick = () => {
    mutate(undefined, {
      onSuccess: () => {
        queryClient.resetQueries();
        localStorage.clear();
        return navigate("/sign-in");
      },
      onError: ()=>{
        return console.log('Log Out')
      }
    });
  };

  return (
    <button
      onClick={onLogOutClick}
      className="flex py-3 text-white items-center gap-2 "
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.0466 2C17.5692 2 18 2.43375 18 2.96V17.04C18 17.5662 17.5692 18 17.0466 18H6.24084C5.71819 18 5.2874 17.5662 5.2874 17.04V14.48L5.92303 15.12V17.04C5.92303 17.22 6.06207 17.36 6.24084 17.36H17.0466C17.2253 17.36 17.3644 17.22 17.3644 17.04V2.96C17.3644 2.77875 17.2266 2.64 17.0466 2.64H6.24084C6.06207 2.64 5.92303 2.78 5.92303 2.96V4.88L5.2874 5.52V2.96C5.2874 2.43375 5.71819 2 6.24084 2H17.0466ZM5.97269 6.19C6.09187 6.21125 6.18746 6.29875 6.22098 6.415C6.2545 6.5325 6.21974 6.6575 6.13159 6.74L3.21167 9.68H12.5971C12.6071 9.68 12.617 9.68 12.6269 9.68C12.802 9.68875 12.9385 9.83875 12.9299 10.015C12.9212 10.1912 12.7722 10.3287 12.5971 10.32H3.21167L6.13159 13.26C6.22595 13.3375 6.2694 13.4612 6.24209 13.5813C6.21477 13.7 6.12166 13.7937 6.00372 13.8212C5.88454 13.8488 5.76164 13.805 5.68467 13.71L2.2185 10.23L2 10L2.2185 9.77L5.68467 6.29C5.75047 6.21875 5.84606 6.1825 5.94289 6.19C5.95282 6.19 5.96276 6.19 5.97269 6.19Z"
          fill="currentColor"
        />
      </svg>
      <Typography type="span">Log out</Typography>
    </button>
  );
}
